var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogCustomLog = function SvgLogCustomLog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19345_59720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 5.33333L2 14",
    stroke: "#64B1FD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58276 6.74333L8.36876 2.96466C9.6581 1.678 11.7454 1.67933 13.0334 2.96666C14.3228 4.256 14.3221 6.34733 13.0314 7.63533L9.24809 11.4113C8.87343 11.7853 8.36476 11.996 7.83543 11.996H3.99609V8.15866C3.99609 7.62733 4.20743 7.118 4.58276 6.74333Z",
    stroke: "#64B1FD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19345_59720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export { SvgLogCustomLog as ReactComponent };
export default __webpack_public_path__ + "log-custom-log.svg";